import { V1ErrorInfo, V1ErrorResponse } from '@bukalapak/openapigen/products/mitrabangunan/product/v1/public/api'
import { AxiosError } from 'axios'

/**
 * Convert any error types (API and client side) to string
 *
 * @example
 * TransactionAPI()
 * .download()
 * .then(() => {........}})
 * .catch(errors) => {
 *   errorToString(errors)
 * })
 */
export default (
  error: AxiosError<V1ErrorResponse> | V1ErrorResponse | (V1ErrorInfo | any)[] | Error | null,
  defaultErrorMessage = 'The server encountered a temporary error and could not complete your request.'
): string => {
  let errorList: Array<V1ErrorInfo | any> = []
  if (error && 'response' in error && error?.response?.data?.errors?.length) {
    errorList = error.response.data.errors
  } else if (error && 'errors' in error && error?.errors?.length) {
    errorList = error.errors
  } else if (error && Array.isArray(error) && error.length > 0) {
    errorList = error
  } else if (error && error instanceof Error) {
    return (error as Error).message || defaultErrorMessage
  } else {
    return defaultErrorMessage
  }
  return errorList
    .map((err: V1ErrorInfo | any) => {
      if (err && err instanceof Object) {
        return err.message || defaultErrorMessage
      }
      return err || defaultErrorMessage
    })
    .join('. ')
}
